<script setup lang="ts">
import type { ARServiceItem } from '@/models/airRoad';

import KTextField from '@/components/fields/KTextField.vue';
import { requiredValidationRule } from '@/helpers/validationRules';

const model = defineModel<ARServiceItem>({
  default: () => ({}),
});
</script>

<template>
  <fieldset
    :class="$style.newAirRoadSpecialOptionSatSrvFieldset"
    data-testid="newAirRoadSpecialOptionSatSrvFieldset"
  >
    <KTextField
      v-model="model.contact_name"
      size="sm"
      label="Name"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <KTextField
      v-model="model.contact_phone"
      size="sm"
      label="Phone"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
  </fieldset>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadSpecialOptionSatSrvFieldset {
}
  .field {
    margin-top: 0.5rem;
  }
</style>
